import { Directive, HostListener, Input, inject } from '@angular/core';
import { TGuideFeature } from '@partners/settings';
import { NavigationAdapter } from '../../navigation';

/**
 * @description
 * this directive to simplify and encapsulate direct navigation to a "guide" type message page
 * (see domain message/guide/...)
 * to use this directive place it on any html element, and give it the name of the guide page
 * component (see TGuideFeature)
 * example:
 * <link-button flow="inline" decoration="underline" guideLink="cvv-guide">מהו CVV?</link-button>
 */
@Directive({
  selector: '[guideLink]',
  standalone: true
})
export class GuideLinkDirective {
  @Input()
  guideLink: TGuideFeature;

  private _navAdapter = inject(NavigationAdapter);

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent | TouchEvent): void {
    this._navAdapter.toGuide(this.guideLink);
  }

  constructor() {}
}
